<template>
  <div class="dashboardPieChart">
    <ApexChart type="pie" :series="series" :options="options" :width="width" :height="height" />
    <p v-if="label">
      {{ label }}
    </p>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';

export default {
  name: 'DashboardPieChart',
  components: {
    ApexChart,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      required: false,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  computed: {
    series() {
      return this.value.map(x => x.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboardPieChart {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem 0rem;
}
</style>
